module.exports = __webpack_public_path__ + "img/06.292b3fcb.png";